// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1az3Y","disabled":"FileBtn_disabled__20KhW","warn":"FileBtn_warn__3j34A","fade":"FileBtn_fade__JOpgw"};